import { useState, useEffect } from 'react'

export default function JourneyProgress({ progress, onViewJourney }) {
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (!progress?.startTime || progress.status === 'completed' || progress.status === 'failed') return

    const interval = setInterval(() => {
      setElapsed(Math.floor((Date.now() - progress.startTime) / 1000))
    }, 1000)

    return () => clearInterval(interval)
  }, [progress?.startTime, progress?.status])

  if (!progress) return null

  const completedEpisodes = progress.completedEpisodes || 0
  const totalEpisodes = progress.totalEpisodes || 1
  const pct = Math.round((completedEpisodes / totalEpisodes) * 100)

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    return m > 0 ? `${m}m ${s}s` : `${s}s`
  }

  return (
    <div className="card bg-base-100 shadow-xl">
      <div className="card-body">
        <h3 className="card-title text-lg">
          {progress.status === 'completed' ? 'Journey Complete' :
           progress.status === 'failed' ? 'Generation Failed' :
           'Generating Journey...'}
        </h3>

        {progress.patientName && (
          <p className="text-base-content/70">Patient: {progress.patientName}</p>
        )}

        {/* Progress bar */}
        <div className="w-full mt-4">
          <div className="flex justify-between text-sm mb-1">
            <span>
              Episode {Math.min(progress.currentEpisode || 0, totalEpisodes)} of {totalEpisodes}
            </span>
            <span>{formatTime(elapsed)}</span>
          </div>
          <progress
            className={`progress w-full ${progress.status === 'completed' ? 'progress-success' : progress.status === 'failed' ? 'progress-error' : 'progress-primary'}`}
            value={progress.status === 'completed' ? 100 : pct}
            max="100"
          ></progress>
        </div>

        {/* Current episode info */}
        {progress.currentTitle && progress.status !== 'completed' && progress.status !== 'failed' && (
          <div className="mt-2 flex items-center gap-2">
            <span className="loading loading-spinner loading-sm"></span>
            <span className="text-sm">
              {progress.currentTitle} ({progress.currentPhase})
            </span>
          </div>
        )}

        {/* Completed state */}
        {progress.status === 'completed' && (
          <div className="mt-4 flex justify-end">
            <button className="btn btn-primary btn-sm" onClick={onViewJourney}>
              View Journeys
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
